/**
 * The MIT License (MIT)
 * https://github.com/aurelia/dependency-injection
 *
 * Copyright (c) 2010 - 2018 Blue Spire Inc.
 */
import 'reflect-metadata';
import { decorateParameterOrProperty } from './decorateParameterOrProperty';
export function Inject(targetOrKey, propertyKey, index) {
    const deco = (k) => decorateParameterOrProperty(x => k || x, 'resolve');
    if (propertyKey == null) {
        return deco(targetOrKey);
    }
    // tslint:disable-next-line:no-non-null-assertion
    return deco()(targetOrKey, propertyKey, index);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5qZWN0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiaW5qZWN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7OztHQUtHO0FBQ0gsT0FBTyxrQkFBa0IsQ0FBQztBQUkxQixPQUFPLEVBQUUsMkJBQTJCLEVBQUUsTUFBTSwrQkFBK0IsQ0FBQztBQVU1RSxNQUFNLFVBQVUsTUFBTSxDQUNsQixXQUErQixFQUMvQixXQUE2QixFQUM3QixLQUFjO0lBRWQsTUFBTSxJQUFJLEdBQUcsQ0FBQyxDQUFZLEVBQUUsRUFBRSxDQUFDLDJCQUEyQixDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxJQUFJLENBQUMsRUFBRSxTQUFTLENBQUMsQ0FBQztJQUNuRixJQUFJLFdBQVcsSUFBSSxJQUFJLEVBQUU7UUFDckIsT0FBTyxJQUFJLENBQUMsV0FBa0IsQ0FBQyxDQUFDO0tBQ25DO0lBRUQsaURBQWlEO0lBQ2pELE9BQU8sSUFBSSxFQUFFLENBQUMsV0FBWSxFQUFFLFdBQVcsRUFBRSxLQUFLLENBQUMsQ0FBQztBQUNwRCxDQUFDIn0=